<form>
    <div class="form-group">
      <label for="name">Unique Identifier:</label>
      <input class="form-control" type="text" id="uid" name="uid" disabled="true" [(ngModel)]="assessment.uid" />
    </div>
    <div class="form-group">
      <label for="name">Name:</label>
      <input class="form-control" type="text" id="name" name="name" disabled="true" [(ngModel)]="assessment.name" />
    </div>
    <div class="form-group">
        <label for="instructions">Instructions:</label>
        <textarea class="form-control" id="instructions" name="instructions" disabled="true" [(ngModel)]="assessment.instructions"></textarea>
    </div> 
    <div class="form-group">
      <label for="therapistDescription">Therapist Description:</label>
      <textarea class="form-control" id="therapistDescription" disabled="true" name="therapistDescription" [(ngModel)]="assessment.therapistDescription"></textarea>
  </div>
    
    <div class="form-group">
        <label for="creator">Creator:</label>
        <input class="form-control" type="text" id="creator" name="creator" disabled="true" [(ngModel)]="assessment.creator" />
    </div>
    <div class="form-group">
        <label for="creator">Creator Url:</label>
        <input class="form-control" type="text" id="creatorUrl" disabled="true" name="creatorUrl" [(ngModel)]="assessment.creatorUrl" />
    </div>
    <div class="form-group">
      <label for="resourcesURL">Resources URL:</label>
      <input class="form-control" type="text" id="resourcesURL" disabled="true" name="resourcesURL" [(ngModel)]="assessment.resourcesURL" />
    </div>
</form>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-details-view/assessment-details-view.component.html